import { VideoInfoRawData } from "../../../model/video/VideoInfo.js";
import { CursoredPlaylist } from "../../playlist/CursoredPlaylist.js";
import { AbstractPlayerControls, QUALITY_PREFERENCE_KEY } from "../AbstractPlayerControls.js";
import { VideoRef } from "../MediaResource.js";
import { VideoContext } from "../Player.js";
import { GenericFormatLabel, ParsedFormat } from "./FormatAndSizePreference.js";
import { VideoContextOverrider } from "./VideoContextOverrider.js";


class InternalWrappedContext extends VideoContextOverrider {

    constructor(ctx: VideoContext, private afterSwitchQuality: (format: ParsedFormat) => void) {
        super(ctx);
    }

    public switchQuality(format: GenericFormatLabel): Promise<any> {
        return this.originalContext.switchQuality(format).then(parsedFmt => {
            this.afterSwitchQuality(parsedFmt)
        });
    }

}
export abstract class VideoAbstractPlayerControls<PlaylistType extends CursoredPlaylist<VideoInfoRawData>> extends AbstractPlayerControls<HTMLVideoElement, VideoInfoRawData, VideoRef, VideoContext, PlaylistType> {

    protected wrapMediaPlayerContext(prevCtx: VideoContext): VideoContext {

        const ctx: VideoContext = new InternalWrappedContext(prevCtx, (format: ParsedFormat) => {
            if (this.config.usePreferenceQuality) {
                localStorage.setItem(QUALITY_PREFERENCE_KEY, `${format.mainSize}`);
            }
        });

        return ctx;
    }
}
